<template>
  <div>
    <h1>Summary QR Registration</h1>
    <hr>
    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="outerBox filterBox">
        <div class="row" style="min-height:110px">
          <div class="col-md-5 col-12 border border-secondary p-2 rounded" >
            <h6>Date From</h6>
            <div class="row">
              <div class="col-md-6 col-12 form-group" style="height:42px" >
                <label>Month</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.month"
                  v-model="selected.from_month"
                  label="name"
                  track-by="value"
                />
            </div>
            <div class="col-md-6 col-12 form-group" style="height:42px" >
              <label>Year</label>
              <MultiSelect
                class="mt-1"
                :options="options.year"
                v-model="filter.from_year"
                />
              </div>
            </div>
          </div>
          <div class="col-md-2 col-12" style="display: flex; flex-direction: column; justify-content: center; text-align: center;">
            <i class="fas fa-arrow-circle-right fa-4x" :class="{'fa-rotate-90 mt-2 mb-2' : mobile}"></i>
          </div>
          <div class="col-md-5 col-12 border border-secondary p-2 rounded" >
            <h6>Date To</h6>
            <div class="row">
              <div class="col-md-6 col-12 form-group" style="height:42px" >
                <label>Month</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.month"
                  v-model="selected.to_month"
                  label="name"
                  track-by="value"
                />
              </div>
              <div class="col-md-6 col-12 form-group" style="height:42px" >
                <label>Year</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.year"
                  v-model="filter.to_year"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 mt-3">
            <button class="w-100 btn btn-primary" type="button" @click="fetchData()">Filter</button>
          </div>
          <div class="col-md-2 mt-3">
            <button class="w-100 btn btn-success" type="button" @click="downloadExcel()">
              <span class="fa fa-file-excel"></span>&nbsp;&nbsp;Export To Excel
            </button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->
    <template v-if="data.length > 0">

      <QRRegistrationChart
        
        :data="data"
      ></QRRegistrationChart>

      
      <table class="table text-center">
        <thead>
          <tr style="background-color:black;color:white">
            <th>Month</th>
            <th>Year</th>
            <th>H1</th>
            <th>H2</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(datum, index) in data" :key="index">
            <td>{{datum.bulan}}</td>
            <td>{{datum.tahun}}</td>
            <td>{{numberWithCommas(datum.h1)}}</td>
            <td>{{numberWithCommas(datum.h2)}}</td>
            <td>{{numberWithCommas(datum.total)}}</td>
          </tr>
          <tr>
            <td colspan="2"><b>Total QR</b></td>
            <td>{{numberWithCommas(dataTotal.h1)}}</td>
            <td>{{numberWithCommas(dataTotal.h2)}}</td>
            <td>{{numberWithCommas(dataTotal.total)}}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-else>
      <div style="display:flex;justify-content:center;align-items:center">
        <div class="spinner-border m-5" role="status" style="width:4rem;height:4rem">
          <span class="sr-only">Loading...</span>
        </div>
        <span class="ml-5" style="font-size:3rem">Loading Data.......</span>

      </div>
    </template>

  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import flatPickr from 'vue-flatpickr-component'
  import moment, { months } from 'moment'

  import QRRegistrationChart from './children/QRRegistrationChart'

  export default {
    data () {
      let startOfYear = new moment().startOf('year');
      return {
        mobile : this.isMobile(),
        options : {
          month : [],
          year : []
        },
        selected: {
          from_month:  {
            name: startOfYear.format("MMMM"),
            value: startOfYear.format("M")
          },
          to_month:  {
            name: new moment().format("MMMM"),
            value: new moment().format("M")
          },
        },
        filter: {
          from_month: startOfYear.format("M"),
          from_year:  startOfYear.format("YYYY"),
          to_month:  new moment().format("M"),
          to_year:  new moment().format("YYYY")
        },
        vue_universal_table : {
          fields : [
            {
              title : 'ID',
              variable : 'owner_id'
            },
            {
              title : 'Name',
              variable : 'name'
            },
            {
              title : 'Identity Number',
              variable : 'id_card'
            },
            {
              title : 'Email',
              variable : 'email'
            },
            {
              title : 'Engine No',
              variable : 'engine_no'
            },
            {
              title : 'Frame No',
              variable : 'frame_no'
            },
            {
              title : 'Current Location',
              variable : 'current_loc_code'
            },
            {
              title : 'Active Date',
              variable : 'active_date'
            },
            {
              title : 'Vehicles Owned',
              variable : 'vehicles_owned'
            }
          ],
          update : 0,
        },
        range: '',
        showExcelModal: false,
        error: '',
        rangeConfig: {
          mode: 'range',
          altInput: true,
          animate: !this.isRTL()
        },
        data : [],
        dataTotal : {
          month : 'Total QR',
          year : '',
          h1 : 0,
          h2 : 0,
          total : 0
        }
      }
    },
    components : {
      flatPickr,
      MultiSelect,
      QRRegistrationChart
    },
    mounted () {
      this.getFilterOptions()
      this.fetchData()
    },
    watch : {
      selected : {
        handler () {
          this.filter.from_month = this.selected.from_month.value;
          this.filter.to_month = this.selected.to_month.value;
        },
        deep : true,
      }
    },
    methods : {
      calculateTotals () {
        this.dataTotal = {
          month : 'Total QR',
          year : '',
          h1 : 0,
          h2 : 0,
          total : 0
		    }
        for(var i = 0 ;  this.data.length ; i++) {
          this.dataTotal.h1 += parseInt(this.data[i].h1)
          this.dataTotal.h2 += parseInt(this.data[i].h2)
          this.dataTotal.total += parseInt(this.data[i].total)
        }
      },
      getFilterOptions () {
        this.options.month = this.$store.getters.getMonth;
        this.options.year = this.$store.getters.getYear;
      },
      async fetchData () {
        this.data.length = 0;

        this.$http.get('/api/reports/summary/qr-registration?' + await this.initialiseFilter())
        .then((resp)=>{
          var data = resp.data.data;
          for(var i = 0; i < data.length; i++){
            data[i].total = parseInt(data[i].h1) + parseInt(data[i].h2)
          }
          this.data = data;
        })
        .then(() => {
          this.calculateTotals()
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      async downloadExcel (filter) {
        let url = '/api/reports/summary/qr-registration/download-excel?' + await this.initialiseFilter()

        this.$http.get(url , {responseType : 'blob'})
        .then((resp)=>{
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = `Summary QR Registration (${this.selected.from_month.name} ${this.filter.from_year} to ${this.selected.to_month.name} ${this.filter.to_year})`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      initialiseFilter(){
        if(!(typeof this.filter === 'object' && this.filter !== null)){
          this.filterUrl = '';
          return;
        }
        var keys = Object.keys(this.filter);
        let stringUrl = '';
        var queryParams = this.filter;

        for(var i = 0 ; i < keys.length; i++){
          if(!queryParams[keys[i]])
            continue;

          if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
            continue 

          if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
            continue;
          
          // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
          //   queryParams[keys[i]] += ":00";

          stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
          
        }
        
        return stringUrl;
      },
    }
  }
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 1020;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
  }

  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }

  .modal-container {
      width: 100%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
      margin-top: 0;
      color: #42b983;
  }

  .modal-body {
      margin: 20px 0;
  }

  .modal-default-button {
      float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
      opacity: 0;
  }

  .modal-leave-active {
      opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
      margin:0
  }

  .modal-body .moduleLine{
      margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
      text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
      background-color: #E0E0E0;
      transition: background-color 0.7s ease;
      color: #212121;
      transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
      border:1px solid #BDBDBD;
      border-radius: 20px;
      padding: 20px 0;
      color:black;
      margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
      font-size:5vh;
  }

  h3.modalHeadline{
      margin:0 0 20px 0;
      font-weight: bold;
      text-align : center;
  }
  /* MODAL ENDS */
</style>
